import React from "react";
import { FaTag, FaCode, FaGlobeAmericas, FaLightbulb, FaFileAlt } from "react-icons/fa";

export const tipoConfig = {
  marca: {
    label: "Registro de Marca",
    icon: FaTag,
    className: "inpi-tipo inpi-tipo--marca",
  },
  software: {
    label: "Registro de Software",
    icon: FaCode,
    className: "inpi-tipo inpi-tipo--software",
  },
  marca_internacional: {
    label: "Marca Internacional",
    icon: FaGlobeAmericas,
    className: "inpi-tipo inpi-tipo--marca-int",
  },
  patente: {
    label: "Patente",
    icon: FaLightbulb,
    className: "inpi-tipo inpi-tipo--patente",
  },
  outro: {
    label: "Outro",
    icon: FaFileAlt,
    className: "inpi-tipo inpi-tipo--outro",
  },
};

export function TipoIcon({ tipo, showLabel = false }) {
  const config = tipoConfig[tipo] || tipoConfig.outro;
  const Icon = config.icon;
  return (
    <div className="inpi-tipo-wrap">
      <span className={`inpi-tipo-icon ${config.className}`}>
        <Icon size={14} />
      </span>
      {showLabel && <span className="inpi-tipo-label">{config.label}</span>}
    </div>
  );
}
